import { render } from "./EnterVideo.vue?vue&type=template&id=3916f6d1&scoped=true&ts=true"
import script from "./EnterVideo.vue?vue&type=script&lang=ts"
export * from "./EnterVideo.vue?vue&type=script&lang=ts"

import "./EnterVideo.vue?vue&type=style&index=0&id=3916f6d1&scoped=true&lang=scss"

import exportComponent from "/data/.jenkins/workspace/k8s-shouba-exhibitionhall-h5-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3916f6d1"]])

export default __exports__